export interface ProjectSectorFilter {
  key: string;
  label: string;
  urlKey: string;
  type: 'constructionSector';
}

// Project-specific sector roots (alphabetical order) - no shared filter with profiles
export const PROJECT_SECTOR_FILTERS: Array<ProjectSectorFilter> = [
  {
    key: 'assembly',
    label: 'Assembly',
    urlKey: 'assembly',
    type: 'constructionSector',
  },
  {
    key: 'civil_infrastructure',
    label: 'Civil & Infrastructure',
    urlKey: 'civil-infrastructure',
    type: 'constructionSector',
  },
  {
    key: 'commercial',
    label: 'Commercial',
    urlKey: 'commercial',
    type: 'constructionSector',
  },
  {
    key: 'industrial',
    label: 'Industrial',
    urlKey: 'industrial',
    type: 'constructionSector',
  },
  {
    key: 'institutional',
    label: 'Institutional',
    urlKey: 'institutional',
    type: 'constructionSector',
  },
  {
    key: 'mixed_use',
    label: 'Mixed-Use',
    urlKey: 'mixed-use',
    type: 'constructionSector',
  },
  {
    key: 'recreation',
    label: 'Recreation',
    urlKey: 'recreation',
    type: 'constructionSector',
  },
  {
    key: 'residential',
    label: 'Residential',
    urlKey: 'residential',
    type: 'constructionSector',
  },
];

export interface ProjectDetailsFilter {
  key: string;
  label: string;
  urlKey: string;
  type: 'projectDetails';
}

export interface FundingTypeFilter {
  key: string;
  label: string;
  urlKey: string;
  type: 'fundingType';
}

export const PROJECT_DETAILS_FILTERS: Array<ProjectDetailsFilter> = [
  {
    key: 'bidding-soon',
    label: 'Bids Due Soon',
    urlKey: 'bidding-soon',
    type: 'projectDetails' as const,
  },
  {
    key: 'pre-bid-meeting',
    label: 'Pre-Bid Meeting',
    urlKey: 'pre-bid-meeting',
    type: 'projectDetails' as const,
  },
  {
    key: 'require-nda',
    label: 'NDA Required',
    urlKey: 'require-nda',
    type: 'projectDetails' as const,
  },
  {
    key: 'bidding-closed',
    label: 'Bidding Closed',
    urlKey: 'bidding-closed',
    type: 'projectDetails' as const,
  },
];

export const FUNDING_TYPE_FILTERS: Array<FundingTypeFilter> = [
  {
    key: 'public-sector',
    label: 'Public',
    urlKey: 'public-sector',
    type: 'fundingType' as const,
  },
  {
    key: 'private-sector',
    label: 'Private',
    urlKey: 'private-sector',
    type: 'fundingType' as const,
  },
].sort((a, b) => a.label.localeCompare(b.label));

export const getProjectDetailsFilters = () => PROJECT_DETAILS_FILTERS;
export const getFundingTypeFilters = () => FUNDING_TYPE_FILTERS;

export const getStaticProjectFilters = () => ({
  projectDetails: PROJECT_DETAILS_FILTERS,
  fundingType: FUNDING_TYPE_FILTERS,
});
